<script lang="ts">
  import InboxWorkflowPreconfigurationBox from "@kontextwerk/control-web-frame/shared/modules/inbox-workflow-preconfiguration-box"
  import type { InboxWorkflowPreconfigurationProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import {
      notifyInboxWorkflowPreconfigurationApplyResult,
      resolveInboxWorkflowPreconfigurationTargets,
  } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import {
    KEEP_PRECONFIGURATION_VALUE,
    isKeepPreconfigurationChoice,
    withKeepPreconfigurationOption,
    type PreconfigurationChoice,
  } from "../../../../../../../../../../../../_shared/_logic/preconfiguration-keep"
  import type {
    ContactPointDecision,
    ContactPointReviewDraft,
    ContactPointReviewRow,
  } from "../../contract"

  let {
    rows,
    selectedIds,
    patchRows,
    disabled = false,
  }: InboxWorkflowPreconfigurationProps<ContactPointReviewRow, ContactPointReviewDraft> = $props()

  // The decision starts per row from the submitted and existing contact value, so it keeps.
  let action = $state<PreconfigurationChoice<ContactPointDecision>>(KEEP_PRECONFIGURATION_VALUE)

  const targetResolution = $derived(
    resolveInboxWorkflowPreconfigurationTargets({
      rows,
      selectedIds,
      getId: (row) => row.actionCaseId,
      isEligible: (row) =>
        !row.disabled &&
        row.reviewKind !== "delete_contact_point" &&
        (action !== "replace" || Boolean(row.existingContactValue.trim())),
    }),
  )

  const apply = () => {
    if (!isKeepPreconfigurationChoice(action)) {
      patchRows(targetResolution.targetRows, {
        action,
      } satisfies Partial<ContactPointReviewDraft>)
    }

    notifyInboxWorkflowPreconfigurationApplyResult({
      total: targetResolution.targetRows.length + targetResolution.skippedRows.length,
      applied: targetResolution.targetRows.length,
      skipped: targetResolution.skippedRows.length,
      reason:
        action === "replace"
          ? "Zeilen ohne bisherigen Kontaktwert können nicht ersetzt werden."
          : undefined,
    })
  }
</script>

<InboxWorkflowPreconfigurationBox
  selectedCount={selectedIds.length}
  targetCount={targetResolution.targetRows.length}
  {disabled}
  onApply={apply}
>
  <div class="preconfiguration-grid">
    <Input
      type="select"
      label="Entscheidung"
      bind:value={action}
      brightBackground={false}
      surfaceTone="dark"
      options={withKeepPreconfigurationOption([
        { value: "append", name: "Ergänzen" },
        { value: "replace", name: "Ersetzen" },
        { value: "reject", name: "Ignorieren" },
      ])}
    />
  </div>
</InboxWorkflowPreconfigurationBox>

<style>
  .preconfiguration-grid {
    padding-top: 1rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: minmax(12rem, 1fr);
    max-width: 32rem;
  }
</style>
